<div class="left_nav-container">
    <h4>Request a Clinic</h4>
    <ul>
        <!-- <li><a routerLink="/contact" routerLinkActive="active">Contact</a></li>
        <li><a routerLink="/organisation" routerLinkActive="active">Organization</a></li>
        <li><a routerLink="/services" routerLinkActive="active">Services</a></li>
        <li><a routerLink="/clinic-details" routerLinkActive="active">Clinic Details</a></li>
        <li><a routerLink="/billing" routerLinkActive="active">Coverage Options</a></li>
        <li><a routerLink="/review-details" routerLinkActive="active">Review and Submit</a></li> -->

        <li><a [class]="getCSS(this.currentRoute,'/contact')">Contact</a></li>
        <li ><a [class]="getCSS(this.currentRoute,'/organisation')">Organization</a></li>
        <li ><a [class]="getCSS(this.currentRoute,'/services')">Services</a></li>
        <li ><a [class]="getCSS(this.currentRoute,'/clinic-details')">Clinic Details</a></li>
        <li><a [class]="getCSS(this.currentRoute,'/billing')">Coverage Options</a></li>
        <li ><a [class]="getCSS(this.currentRoute,'/review-details')">Review and Submit</a></li>
    </ul>
</div>